import React from "react";
import storageManager from "../Utility/StorageManager";

const Logout = () => {
  const logout = () => {
    const check = window.confirm(`Are you sure you want to logout?`);
    if (check) {
      storageManager.clear();
      window.location.reload(true);
    }
  };

  return (
    <button className="absolute right-2 p-4" onClick={() => logout()} to="/login">
      Logout
    </button>
  );
};

export default Logout;
